const { setInitialised, useDots, useArrows } = window.BAO.Carousel.plugins

class ProductUpsells extends window.BAO.CustomElement() {
  connectedCallback () {
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    const count = this.els?.slide?.elements?.length || 0
    const desktopPerView = count > 0 && count < 4 ? count : 4
    const tabletPerView = count > 0 && count < 2 ? count : 2

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: tabletPerView,
              spacing: 30,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: desktopPerView,
              spacing: 30,
            },
          },
        },
      },
      [
        setInitialised(),
        useDots(this.els?.dot?.elements),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-upsells')) {
  customElements.define('product-upsells', ProductUpsells)
}
